import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Answer, AssessmentResponse } from "@data/assessment";
import { API } from "@service/system/api.service";
import { HttpManager } from "@service/system/httpManager.service";
import { ServiceResponse } from "@data/response";
import { ResponseHandler } from "@service/system/responseHandler.service";

const API_URL = API.API_URL;

@Injectable()
export class AssessmentsService {
	private _assessmentsURL = API_URL + "/assessments";

	constructor(private httpManager: HttpManager, private responseHandler: ResponseHandler) {}

	getAssessmentsByTitle(title: string | string[]): Observable<any> {
		return this.httpManager.httpGet<any>(`${this._assessmentsURL}/find`, { title: title });
	}

	getAssessmentByGUID(GUID: any): Observable<any> {
		return this.httpManager.httpGet<any>(`${this._assessmentsURL}/find`, { guid: GUID });
	}

	getAssessmentQuestionsByGUID(GUID: string, status: string): Observable<any> {
		return this.httpManager.httpGet<any>(`${this._assessmentsURL}/${GUID}/questions`, { status: status });
	}

	getAssessmentQuestionSingleByQuestionID(QuestionID: string): Observable<any> {
		return this.httpManager.httpGet<any>(this._assessmentsURL + "/questions/" + QuestionID);
	}

	getQuestionAnswersByID(QuestionID: string): Observable<any> {
		return this.httpManager.httpGet<any>(this._assessmentsURL + "/question/" + QuestionID + "/answers");
	}

	getQuestionAnswersByGUID(GUID: string, status: string): Observable<any> {
		return this.httpManager.httpGet<any>(`${this._assessmentsURL}/${GUID}/answers`, { status: status });
	}

	getQuestionRemediationsByGUID(GUID: string, status: string): Observable<any> {
		return this.httpManager.httpGet<any>(this._assessmentsURL + "/" + GUID + "/remediations", { status: status });
	}

	getQuestionRemediationsByID(QuestionID: string): Observable<any> {
		return this.httpManager.httpGet<any>(this._assessmentsURL + "/question/" + QuestionID + "/remediation");
	}

	getEvaluationQuestionsByGUID(GUID: string, status: string): Observable<any> {
		return this.httpManager.httpGet<any>(`${this._assessmentsURL}/evaluation/${GUID}/questions`, {
			status: status
		});
	}

	getEvaluationQuestionAnswersByGUID(GUID: string, status: string): Observable<any> {
		return this.httpManager.httpGet<any>(`${this._assessmentsURL}/evaluation/${GUID}/answers`, { status: status });
	}

	updateQuestionAnswers(questionId: number, answers: Answer[]): Observable<any> {
		return this.httpManager.httpPatch<any>(`${this._assessmentsURL}/question/${questionId}/answers`, answers);
	}

	loadAssessmentXml(cvItemID: string, body: string): Observable<ServiceResponse<AssessmentResponse>> {
		return this.responseHandler.httpPost<AssessmentResponse>(`${API_URL}/import/assessment/${cvItemID}/xml`, {
			EncodedXml: body
		});
	}
}
